/*
 * General form stuff as well as site specific form
 * js can go here
 */

if (typeof ($) === 'undefined') {
    window.$ = jQuery;
}

window.fetch = new Proxy(window.fetch, {
    apply(actualFetch, that, args) {
        // Forward function call to the original fetch

        const result = Reflect.apply(actualFetch, that, args);
        result.then((response) => {
            if(response.status >= 400 && args[0].search('contact-form-7') > -1){
                jQuery(document).trigger('syn:fetch-error:wpcf7', {
                    response: response,
                    url: args[0]
                });
            }else if(response.status >= 400){
                jQuery(document).trigger('syn:fetch-error', {
                    response: response,
                    url: args[0]
                });
            }
        });

        return result;
    }
});

jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    jqXHR.fail(function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status >= 400 && options.url.search('contact-form-7') > -1) {
            jQuery(document).trigger('syn:fetch-error:wpcf7', {
                response: jqXHR,
                url: options.url
            });
        } else if (jqXHR.status >= 400) {
            jQuery(document).trigger('syn:fetch-error', {
                response: jqXHR,
                url: options.url
            });
        }
    });
});

$(document).ready(function () {

    jQuery(document).on('syn:fetch-error syn:fetch-error:cf7', function (e, data) {
        console.error('Fetch Error:', data.response);
        console.error('URL:', data.url);
    });

    /*
     * This is a hook to catch all form submissions
     */
    $('body').on('submit', '.wpcf7-form', function () {
        if (!$(this).hasClass('no-loading-submit')) {
            setTimeout(showLoadingBlock(this), 3000)
        }

        var $form = $(this);
        var form_id = $form.find('input[name="_wpcf7"]').val();
    });

    // Catch wpcf7 errors
    $('body').on('wpcf7:invalid wpcf7:spam wpcf7invalid wpcf7spam', '.wpcf7', function (e) {
        if (!$(this).hasClass('no-error-scroll')) {
            var $errors = $(this).find('.wpcf7-not-valid-tip');
            if ($errors.length > 0) {
                var $form_parent = $(this).parent();

                var scrollTo = Math.max(0, $errors.first().offset().top - 300);
                if ($form_parent.length) {
                    $form_parent.animate({
                                             scrollTop: scrollTo
                                         }, 1000);
                } else {
                    $('html, body').animate({
                                                  scrollTop: scrollTo
                                              }, 1000);
                }

            }
        }

        // console.log($(evt.target).find('button.google-recaptcha'));
        if ($(e.target).find('button.google-recaptcha').length) {
            // console.log($(e.target).find('button.google-recaptcha'));
            var widget_id = $(e.target).find('button.google-recaptcha').attr('data-widget-id');
            googleRecaptcha.reset(widget_id);
        }

        hideLoadingBlock();
    });

    $('body').on('wpcf7:mailsent wpcf7mailsent', '.wpcf7', function (e) {
        /*
         * Event Listener for on successful CF7 mail send.
         * @version 5.0
         * @Deprecated on_sent_ok
         */
        if (e.detail && e.detail.apiResponse) {
            if (e.detail.apiResponse.hasOwnProperty('synapse_events')) {
                if (e.detail.apiResponse.synapse_events.hasOwnProperty('on_sent_ok')) {
                    var sent_ok = e.detail.apiResponse.synapse_events.on_sent_ok;

                    if (Array.isArray(sent_ok)) {
                        $.each(sent_ok, function (key, item) {
                            eval(item);
                        });
                    } else {
                        eval(sent_ok);
                    }
                } else if (Array.isArray(e.detail.apiResponse.synapse_events)) {
                    $.each(e.detail.apiResponse.synapse_events, function (key, item) {
                        eval(item);
                    });
                }
            }
        }

        hideLoadingBlock();
    });

    $('body').on('wpcf7:mailfailed wpcf7mailfailed', '.wpcf7', function () {
        hideLoadingBlock();
    });

    $('body').on('focus', '.wpcf7-form-control', function(){
        var $this = $(this);
        var $form = $this.closest('.wpcf7-form');
        var intent = $form.data('intent');
        if(!intent){
            var id = $form.find('input[name="_wpcf7"]').val();
            $.post('/wp-json/syn_custom/v1/form-fill-intent', {form_id: id}, function(response){
                $form.data('intent', 'true');
                if(response && response.uuid){
                    $form.append('<input type="hidden" name="uuid">')
                    $form.find('input[name="uuid"').val(response.uuid);
                }
            });
        }
    });

    // $('input.tel-mask-no-ext').mask("(999) 999-9999", { placeholder: "_ " });
    // $('input.tel-mask').mask("(999) 999-9999? x:99999", { placeholder: "_ " });
    // $('input.us-zip').mask("99999", { placeholder: "_ " });
    // $('input.us-zip-extended').mask("99999?-9999", { placeholder: "_ " });
    // $('input.ssn-mask').mask("999 - 99 - 9999", { placeholder: "_ " });
    // $('input.date-mmyy').mask("99/99", { placeholder: "_ " });
    // $('input.date-mmddyy').mask("99/99/99", { placeholder: "_ " });
    // $('input.date-mmddyyyy').mask("99/99/9999", { placeholder: "_ " });
    // $('input.date-yy').mask("9?9", { placeholder: " " });

    function showLoadingBlock(form) {
        // console.log(window.SynVal)
        if(typeof window.SynVal.new_loader == 'undefined' || window.SynVal.new_loader != true){
            var loading = '<div class="loading-block">';
            loading += '<div class="loading-block-image-wrapper">';
            loading += '<img src="' + window.SynVal.icon + '" />';
            loading += '</div>';
            loading += '</div>';
        }else{
            var loading = '<div class="loading-block">';
            loading += '<div class="loading-block-loader-wrapper">';
            loading += window.SynVal.loader;
            loading += '</div>';
            loading += '</div>';
        }
        $(form).append(loading);
        $(form).find('.loading-block').css('lineHeight', $(form).height() + 'px').fadeIn('1000');
    }

    function hideLoadingBlock() {
        $('.loading-block').fadeOut('1000', function () {
            $(this).remove();
        });
    }


});

